import { z, isoZ } from 'my-zod'

export const subscriptionRenewalsModel = z.object({
  id: z.string().uuid(),
  memberId: z.string().uuid(),
  subscriptionId: z.string(),
  subscriptionCreditImpact: z.number(),
  billingServiceInvoiceId: z.string(),
  creditEventId: z.number(),
  createdDate: isoZ.instant()
})

export type subscriptionRenewalsModel = z.infer<typeof subscriptionRenewalsModel>
